import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
} from "react-admin";
import { useLocation } from "react-router-dom";
import { getAuthData } from "../constant/constant";

const PresenceCreate = () => {
  const query = new URLSearchParams(useLocation().search);
  const scannedDate = query.get("date") || "";

  const auth = getAuthData();
  const username = auth?.username || auth?.niplama || "";

  return (
    <Create redirect="/scanqr">
      <SimpleForm
        defaultValues={{
          username,
          tanggal: scannedDate,
        }}
      >
        <TextInput source="username" label="Username" disabled />

        <SelectInput
          source="status"
          label="Status"
          choices={[
            { id: "Masuk", name: "Masuk" },
            { id: "Keluar", name: "Keluar" },
          ]}
          validate={[required()]}
        />

        <TextInput source="tanggal" label="Tanggal" disabled />
      </SimpleForm>
    </Create>
  );
};

export default PresenceCreate;